import { z } from 'zod';

export const feedItemSchema = z.object({
  id: z.string().uuid(),
  feed_id: z.string().uuid(),
  guid: z.string().min(1),
  title: z.string().min(1),
  url: z.string().url(),
  content: z.string().nullable(),
  author: z.string().nullable(),
  published_at: z.string().datetime().nullable(),
  ai_relevance_score: z.number().nullable().optional(),
  created_at: z.string().datetime(),
});

export type FeedItem = z.infer<typeof feedItemSchema>;
